import { sendRequestAuth } from 'api/api'
import { convertDateTimeToApiFormat } from 'common/form/datePicker/_functions'
import config from 'config'
import { useReducer } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  receiptActions,
  receiptReducer,
} from '../provider/_reducer'

import {
  receiptInitialState,
} from '../provider/_initState'

const useReceipt = () => {
  const [searchParams] = useSearchParams()
  const nav = useNavigate()
  const [state, dispatch] = useReducer(receiptReducer, receiptInitialState)
  const { filter, table } = state

  const filterQueries = {
    date_type: filter.dateTime?.activeValue?.type?.value || '',
    start_date:
      filter.dateTime.activeValue?.start && filter.dateTime.activeValue.value
        ? convertDateTimeToApiFormat(
        filter.dateTime.activeValue.value.split(' - ')[0],
        )
        : '',
    end_date:
      filter.dateTime.activeValue?.end && filter.dateTime.activeValue.value
        ? convertDateTimeToApiFormat(
        filter.dateTime.activeValue.value.split(' - ')[1],
        )
        : '',
    payment_status: filter.status.activeValue?.value || '',
    month_time: filter.monthTime.activeValue || '',
    payment_method: filter.receiptType.activeValue?.value || '',
    principal_id: filter.principal.activeValue?.value?.value || '',
    user_id: filter.employee.activeValue?.value?.value || '',
    tracking_code: filter.receiptInfo.activeValue || '',
  }

  const fetchRowDetail = async data => {
    if (!!!data?.id) {
      dispatch({
        type: receiptActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: false } } },
      })
      return
    }

    const response = await sendRequestAuth(
      'get',
      `${config.API}/receipt/detail/${data?.id}`,
    )

    if (!!response?.data?.success) {
      const newItem = response?.data?.data
      dispatch({
        type: receiptActions.TABLE_DISPLAY_DETAIL_UPDATE,
        payload: { active: newItem, list: [newItem] },
      })
    }

    dispatch({
      type: receiptActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: false } } },
    })
  }

  const handleOriginFetch = async () => {

    const querySearch = searchParams.get('search') || ''
    if (querySearch)
      dispatch({
        type: receiptActions.FILTER_ACTIVE_DATE_TIME_UPDATE,
        payload: {
          end: '',
          start: '',
          type: filter.dateTime.type,
          value: '',
        },
      })
    const response = await sendRequestAuth(
      'get',
      `${config.API}/receipt/receipts?tracking_code=&principal_id=&user_id=&month_time=&payment_method=&payment_status=&start_date=&end_date=&start=0&per_page=20`,
    )

    if (!!response?.data?.success) {
      const displayListData = Array.isArray(response?.data?.data)
        ? response.data.data
        : []
      // set default value for input filter
      dispatch({
        type: receiptActions.FILTER_SEARCH_UPDATE,
        payload: { value: querySearch },
      })
      // update display list
      dispatch({
        type: receiptActions.TABLE_AMOUNT_UPDATE,
        payload: {
          display: {
            list: displayListData,
          },
          pagination: {
            totalItems: response?.data?.meta?.total || 0,
            active: 0,
            amount: 20,
            total: response?.data?.meta?.total
              ? Math.ceil(
                response?.data?.meta?.total / 20,
              )
              : 0,
          },
        },
      })
      // auto fetch detail receipt id and open
      if (querySearch) {
        dispatch({
          type: receiptActions.TABLE_DISPLAY_DETAIL_UPDATE,
          payload: { active: displayListData[0] },
        })
        fetchRowDetail({ id: querySearch })
      }
    }

    if (!querySearch) {
      dispatch({
        type: receiptActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: false } } },
      })
    }
  }

  const handleDetailFetch = async (receiptId) => {
    const response = await sendRequestAuth(
      'get',
      `${config.API}/receipt/detail/${receiptId}`,
    )

    if (!!response?.data?.success) {
      // set default value for input filter
      const receiptDetail = response.data.data
      if(!['new','processing'].includes(receiptDetail.receipt_status)) nav('/receipt/digital')
      dispatch({
        type: receiptActions.UPDATE_ORIGIN_DATA_FORM_EDIT,
        payload: {
          receipt: receiptDetail,
          receiptName: {
            value: receiptDetail?.receipt_name,
            status: true,
            message: ''
          },
          receiptPhone: {
            value: receiptDetail?.receipt_phone,
            status: true,
            message: ''
          },
          receiptEmail: {
            value: receiptDetail?.receipt_email,
            status: true,
            message: ''
          },
          receiptAddress: {
            value: receiptDetail?.receipt_address,
            status: true,
            message: ''
          },
          receiptNotes: {
            value: receiptDetail?.receipt_notes,
            status: true,
            message: ''
          },
          feeShip: {
            value: receiptDetail?.shipping_fee,
            status: true,
            message: ''
          },
          details: receiptDetail?.details,
        },
      })
    }
  }


  const handleFetchDetailHistory = async (historyId) => {
    const response = await sendRequestAuth(
      'get',
      `${config.API}/receipt/log/detail/${historyId}`,
    )

    if (!!response?.data?.success) {}
  }

  const handlePaginationAmountChange = async n => {
    dispatch({
      type: receiptActions.TABLE_SELECTED_LIST_UPDATE,
      payload: { selected: { list: [] } },
    })
    dispatch({
      type: receiptActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: true } } },
    })

    const currentPage = table.pagination.active || 0
    const totalPages = Math.ceil(table.pagination.totalItems / n)
    const page =
      table.pagination.totalItems < currentPage * n
        ? totalPages - 1
        : currentPage

    let queryStr = '?'
    let i = 0
    for (const [key, value] of Object.entries({
      ...filterQueries,
      type: 1,
      per_page: n,
      start: page * n,
    })) {
      queryStr += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }

    const response = await sendRequestAuth(
      'get',
      `${config.API}/receipt/receipts${queryStr}`,
    )

    if (!!response?.data?.success) {
      const displayListData = Array.isArray(response?.data?.data)
        ? response.data.data
        : []
      dispatch({
        type: receiptActions.TABLE_AMOUNT_UPDATE,
        payload: {
          display: {
            list: displayListData,
          },
          pagination: { active: page, amount: n, totalItems: response?.data?.meta?.total || 0,total: totalPages },
        },
      })

    }

    dispatch({
      type: receiptActions.TABLE_DISPLAY_DETAIL_UPDATE,
      payload: { active: null },
    })

    dispatch({
      type: receiptActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: false } } },
    })
  }

  const handlePaginationPageChange = async page => {
    dispatch({
      type: receiptActions.TABLE_SELECTED_LIST_UPDATE,
      payload: { selected: { list: [] } },
    })
    dispatch({
      type: receiptActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: true } } },
    })

    const amount = table.pagination?.amount || 20

    let queryStr = '?'
    let i = 0
    for (const [key, value] of Object.entries({
      ...filterQueries,
      type: 1,
      per_page: amount,
      start: page * amount,
    })) {
      queryStr += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }

    const response = await sendRequestAuth(
      'get',
      `${config.API}/receipt/receipts${queryStr}`,
    )

    if (!!response?.data?.success) {
      const displayListData = Array.isArray(response?.data?.data)
        ? response.data.data
        : []

      dispatch({
        type: receiptActions.TABLE_PAGINATION_UPDATE,
        payload: {
          display: {
            list: displayListData,
          },
          pagination: { active: page },
        },
      })
    }

    dispatch({
      type: receiptActions.TABLE_DISPLAY_DETAIL_UPDATE,
      payload: { active: null },
    })

    dispatch({
      type: receiptActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: false } } },
    })
  }

  return {
    fetch: {
      origin: handleOriginFetch,
      detail: handleDetailFetch,
      history: handleFetchDetailHistory,
    },
    pagination: {
      onAmountChange: handlePaginationAmountChange,
      onPageChange: handlePaginationPageChange,
    },
    provider: { state, dispatch },
  }
}

export default useReceipt
